import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  iconButtonText: { fontSize: 14, fontWeight: 700, marginLeft: '10px' },
  icon: { width: '18px', height: '18px' },
  disabled: {
    color: 'rgba(0, 0, 0, 0.26)',
  },
  enable: {
    color: '#E8192C',
  },
}));
